export const UiHide = (hidden: boolean) => {
    let event = new CustomEvent('ui-hide', {
        detail: {
            hidden: hidden,
        },
    });
    window.dispatchEvent(event);
}